import ColoredTimerVerticalTabsComponent from "./colored-timer-vertical-tabs-component";
import ColoredTimerVerticalTabsConfig from "./colored-timer-vertical-tabs-config";
import ColoredTimerVerticalTabsAdvancedConfig from "./colored-timer-vertical-tabs-advanced-config";

export default {
  ColoredTimerVerticalTabsComponent,
  ColoredTimerVerticalTabsConfig,
  ColoredTimerVerticalTabsAdvancedConfig
};
